export default {
  // @ts-ignore
  rest: REST_URL,
  // @ts-ignore
  streaming: STREAMING_URL,
};
